import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { UseCaseGroup, UseCaseTypesEnum, UseCaseVdd } from '@vi-iot/client';
import { Observable } from 'rxjs';

import { RemoteDiagnosticsUseCasesActions } from './remote-diagnostics-use-cases.actions';
import { ExtendedParametersTabsEnum } from './remote-diagnostics-use-cases.model';
import { RemoteDiagnosticsUseCasesSelectors } from './remote-diagnostics-use-cases.selectors';

@Injectable({ providedIn: 'root' })
export class RemoteDiagnosticsUseCasesStore {
  constructor(private store: Store) {}

  loading$ = this.store.select(RemoteDiagnosticsUseCasesSelectors.isLoading());
  selectVddListForUseCaseLoading$ = this.store.select(
    RemoteDiagnosticsUseCasesSelectors.selectVddListForUseCaseLoading$
  );
  useCases$ = this.store.select(RemoteDiagnosticsUseCasesSelectors.getUseCases());

  getSelectedExtendedParametersTab(gatewaySerial: string): Observable<ExtendedParametersTabsEnum> {
    return this.store.select(
      RemoteDiagnosticsUseCasesSelectors.getSelectedExtendedParametersTab(gatewaySerial)
    );
  }

  getSelectedUseCaseType(gatewaySerial: string): Observable<UseCaseTypesEnum> {
    return this.store.select(
      RemoteDiagnosticsUseCasesSelectors.getSelectedUseCaseType(gatewaySerial)
    );
  }

  getSelectedUseCaseGroup(gatewaySerial: string): Observable<string> {
    return this.store.select(
      RemoteDiagnosticsUseCasesSelectors.getSelectedUseCaseGroup(gatewaySerial)
    );
  }

  getUseCaseGroups(gatewaySerial: string): Observable<UseCaseGroup[]> {
    return this.store.select(RemoteDiagnosticsUseCasesSelectors.getUseCaseGroups(gatewaySerial));
  }

  getVddListLoaded(gatewaySerial: string): Observable<boolean> {
    return this.store.select(RemoteDiagnosticsUseCasesSelectors.getVddListLoaded(gatewaySerial));
  }

  loadUseCases(gatewaySerial: string): void {
    this.store.dispatch(RemoteDiagnosticsUseCasesActions.loadUseCasesAttempt({ gatewaySerial }));
  }

  loadUseCaseVddList(gatewaySerial: string, useCase: string): void {
    this.store.dispatch(
      RemoteDiagnosticsUseCasesActions.loadUseCaseVddListAttempt({ gatewaySerial, useCase })
    );
  }

  changeUseCaseType(useCaseType: UseCaseTypesEnum, gatewaySerial: string): void {
    this.store.dispatch(
      RemoteDiagnosticsUseCasesActions.useCaseTypeChanged({ useCaseType, gatewaySerial })
    );
  }

  changeExtendedParametersTab(tab: ExtendedParametersTabsEnum, gatewaySerial: string): void {
    this.store.dispatch(
      RemoteDiagnosticsUseCasesActions.extendedParametersTabChanged({ tab, gatewaySerial })
    );
  }

  changeUseCaseGroup(gatewaySerial: string, useCaseGroupe: string): void {
    this.store.dispatch(
      RemoteDiagnosticsUseCasesActions.useCaseGroupChanged({ gatewaySerial, useCaseGroupe })
    );
  }

  selectUseCaseVddList(gatewaySerial: string, vddList?: UseCaseVdd[]): void {
    this.store.dispatch(
      RemoteDiagnosticsUseCasesActions.selectUseCaseVddList({
        gatewaySerial,
        vddList,
      })
    );
  }
}
